import styled from 'styled-components';

export const Container = styled.div`
  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  text-align: center;

  span {
    color: #fff;
    padding: 10px 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    flex: 1;
    background: #626ed4;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;

    & + button {
      margin-left: 10px;
      background: #ec4561;
    }
  }
`;
